export default "__VITE_ASSET__sQIaz42m__"